import Api from '@api/zhiTuiBao'
import { observable, computed } from 'mobx'
import { GET_EXTRA_NUMBER } from '@components/LocalMerchant/ZhiTuiBao/constant'
import CreativeApi from '@api/creative'
import { message } from 'hljd'
class Store {
  @observable pageData = {}
  @observable warn = {}
  tabsStore = {} // 需要存储tabsStore

  getData = () => {
    this.getDashBoard()
    this.getWarn()
  }

  getDashBoard = async () => {
    const { success, data } = await Api.flowPacketDashboard()

    if (success) {
      this.pageData = data
      this.consume_type = data.consume_type
    }
  }

  getWarn = async () => {
    const { success, data } = await CreativeApi.warn()

    if (success) {
      this.warn = data
    }
  }

  @computed
  get showGetExtraBtn() {
    return this.pageData.now_use_num < GET_EXTRA_NUMBER
  }

  setTabsStore = tabsStore => {
    this.tabsStore = tabsStore
  }

  @observable visible = false

  @observable consume_type = '1'
  onChangeDelivery = e => {
    this.consume_type = e.target.value
  }

  handleOk = async () => {
    const { success } = await Api.changeConsumeType({
      consumeType: this.consume_type
    })
    if (success) {
      message.success('操作成功~')
      this.handleCancel()
      this.getDashBoard()
    }
  }

  handleCancel = () => {
    this.visible = false
    this.consume_type = this.pageData.consume_type
  }

  showDelivery = () => {
    this.visible = true
  }
}

export default Store
